<template>
	<div class="modules">
		<modules-popup
			v-if="active && view === 'popup'"
			:modules="modules"
			:links="links"
		/>

		<modules-panel
			:active="active && view === 'panel'"
			:modules="modules"
			:modules-text="modulesText"
			:links="links"
			@close-modules-panel="$emit('close')"
			@modules-panel-active="$emit('modules-panel-active')"
			@modules-panel-inactive="$emit('modules-panel-inactive')"
		/>
	</div>
</template>

<script>
import ModulesPopup from './modules-popup/ModulesPopup.vue';
import ModulesPanel from './modules-panel/ModulesPanel.vue';

export default {
	components: {
		'modules-popup': ModulesPopup,
		'modules-panel': ModulesPanel,
	},

	props: {
		active: {
			type: Boolean,
			required: true,
		},
		modules: {
			type: Array,
			required: true,
		},

		modulesText: {
			type: String,
			required: false,
			default: null,
		},

		links: {
			type: Object,
			required: false,
			default: null,
		},

		view: {
			type: String,
			required: false,
			default: 'popup',
		},
	},

	mounted() {
		window.addEventListener('keyup', this.checkForEscape);
		window.addEventListener('click', this.closeOutside, true, false);
		window.addEventListener('touchstart', this.closeOutside, true, false);
	},

	beforeDestroy() {
		window.removeEventListener('keyup', this.checkForEscape);
		window.removeEventListener('click', this.closeOutside, true, false);
		window.removeEventListener('touchstart', this.closeOutside, true, false);
	},

	methods: {
		checkForEscape(event) {
			const { keyCode } = event;
			if (keyCode === 27 && this.view === 'popup') {
				this.$emit('close');
			}
		},

		disabledTargets(target) {
			return !target.closest('.modules')
				&& !target.closest('.header__modules')
				&& !target.closest('.modules-panel__panel');
		},

		enabledTargets(target) {
			return target.closest('.panel__close');
		},

		closeOutside(event) {
			const { target } = event;

			if (this.active	&& (this.disabledTargets(target) || this.enabledTargets(target))) {
				this.$emit('close');
			}
		},
	},
};
</script>
